import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BookOpen } from 'lucide-react';
import { MobileSubMenuHeader } from '@/components/layout';
import { navigationItems } from '@/lib/navigation';

interface KnowledgeBaseProps {
  isGlobalDarkMode: boolean;
  onMobileSubMenuToggle?: (menuId: string | null, subItems?: any[], menuLabel?: string) => void;
  isMobile?: boolean;
}

const KnowledgeBase: React.FC<KnowledgeBaseProps> = ({ isGlobalDarkMode, onMobileSubMenuToggle, isMobile = false }) => {
  const handleMobileMenuToggle = () => {
    const boardsMenuItem = navigationItems.find(item => item.id === 'boards');
    if (boardsMenuItem && onMobileSubMenuToggle) {
      onMobileSubMenuToggle('boards', boardsMenuItem.subItems, boardsMenuItem.label);
    }
  };

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Knowledge Base | AgencyPlus</title>
        <meta name="description" content="Knowledge Base" />
        <link rel="canonical" href="/boards/knowledge-base" />
      </Helmet>

      {isMobile && (
        <MobileSubMenuHeader
          onMenuClick={handleMobileMenuToggle}
          isDarkMode={isGlobalDarkMode}
        />
      )}

      <div className={`w-full px-6 md:px-10 py-6 ${isMobile ? 'pt-20' : ''}`}>
        <div className="flex flex-col xl:flex-row xl:items-center justify-between gap-4 mb-8">
          <div>
            <h1 className="text-3xl font-bold text-foreground">Knowledge Base</h1>
            <p className="text-sm text-muted-foreground mt-1">
              Manage your knowledge base articles
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center py-20">
          <div className="w-20 h-20 rounded-2xl flex items-center justify-center mb-6 bg-blue-500/10">
            <BookOpen className="w-10 h-10 text-blue-500" />
          </div>
          <h2 className="text-xl font-bold mb-2 text-foreground">
            Knowledge Base
          </h2>
          <p className="text-center max-w-md text-muted-foreground">
            This page is currently blank and ready for content.
          </p>
        </div>
      </div>
    </div>
  );
};

export default KnowledgeBase;
